import { render } from "./attWhy.vue?vue&type=template&id=f8e1002c&scoped=true"
import script from "./attWhy.vue?vue&type=script&lang=js"
export * from "./attWhy.vue?vue&type=script&lang=js"

import "./attWhy.vue?vue&type=style&index=0&id=f8e1002c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e1002c"]])

export default __exports__